// extracted by mini-css-extract-plugin
export default {"logo":"SubFooter_logo__9d4VD","subFooter":"SubFooter_subFooter__HoU9g"};